<script>
import {mapState} from "vuex";

export default {
  computed: {
    ...mapState(['isFreeUser','msisdn']),
  },
  methods: {
    backProfile() {
      const hasMsisdn = localStorage.getItem('msisdn') || sessionStorage.getItem('msisdn');
      this.$router.push(hasMsisdn ? '/profile' : '/login')
    }
  }
}

</script>

<template>

  <div class='container'>
    <div class='col-12'>
      <div class='col-12'>
        <img :src="isFreeUser ? require('@/assets/logos/logo-free.png') : require('@/assets/logos/logo-vip.png')"  class="col-4 mt-4" alt="logo" />
      </div>

      <div class=' terms-heading text-center col-12 mt-4'>Terms & Conditions </div>
      <div class="px-1">

        <p>A. The following Terms and Conditions contain assumptions of risk and/or liability by
          Customers and limit and exclude liabilities, obligations and legal responsibilities which
          Mobile Telephone Networks Proprietary Limited (“MTN”) will have towards Customers and
          other persons.</p>
        <p>B. These Terms and Conditions also limit and exclude Customers rights and remedies
          against MTN and place various risks, liabilities, obligations and legal responsibilities on
          the Customer.</p>
        <p>C. These Terms and Conditions may result in Customers being responsible for paying
          additional costs and amounts and MTN may also have claims and other rights against the
          Customer.</p>
        <p>D. To the extent that the Terms and Conditions or any goods or services provided under the
          Terms and Conditions are governed by the Consumer Protection Act, 2008 (the
          &quot;Consumer Protection Act&quot;), no provision of the Terms are intended to contravene the
          applicable provisions of the Consumer Protection Act, and therefore all provisions of the
          Terms and Conditions must be treated as being qualified, to the extent necessary, to
          ensure that the applicable provisions of the Consumer Protection Act are complied with.</p>
        <p class="">E. The Customer must read these Terms and Conditions. The use of this product/service will
          constitute as agreement to comply with these Terms and Conditions.</p>
        <p class="">F. Please pay special attention to all the clauses. Please note that these Terms and
          Conditions must be read together with the standard MTN Internet product and service
          Terms and Conditions and the Fanclash Privacy Notice in clause 11 below.</p>

        <h2>1. Introduction</h2>
        <p>1.1 MTN customers who use the Mzansi Rhythm promotions over the promotion
          period stand a chance to win their share of R396 000 (three hundred and ninety-
          six thousand rand) in airtime prizes. MTN Mzansi Rhythm is a subscription service
          that allows users to play a Triva Music Game for R5 per day, R35 per week or R45
          per month (which are subject to change) (“the Promotional Offer”).</p>

        <h2>2. Duration</h2>
        <p>This Promotion is available from the 1st of May 2025 until 30th of April 2026 both days inclusive. ("Promotional
          Period").</p>
        <p>2.2 For the duration of the Promotion Period, daily competitions will be hosted.</p>
        <p>2.3 Notwithstanding the Promotion Period, MTN may, in its sole and absolute
          discretion, amend the duration of the Offer Period to a shorter or longer period, or
          withdraw the offer in its entirety, with notice to you. Visit <a href="www.mtn.co.za">www.mtn.co.za</a> or *123#
          for notices, updates and/or changes to services.
        </p>

        <h2>Game Play</h2>
        <table>
          <tr>
            <th>Start Date</th>
            <td>1st of May 2025</td>
          </tr>
          <tr>
            <th>End Date</th>
            <td>30th of April 2026</td>
          </tr>
          <tr>
            <th>Prizes</th>
            <td>Users will be awarded airtime based on the outcome of their gameplay in daily competitions.</td>
          </tr>
        </table>

        <h2>3. Who is Eligible?</h2>
        <ul>
          <li>3.1 Only entries received during the promotional period will quality to enter the daily
            competition.
          </li>
          <li>3.2 To be eligible the customer must do the following:</li>
          <ul>
            <li>3.1.1. be a South African citizen.</li>
            <li>3.1.2. be residing in South Africa.</li>
            <li>3.1.3. be a natural person.</li>
            <li>3.1.4. be 18 years or older.</li>
            <li>3.1.5. be an MTN subscriber (PayAsYouGo, TopUp or Contract)</li>
            <li>3.1.6. subscribe to Mzansi Rhythm at R5.00 per day, R35 per week or R45 per
              month.
            </li>
            <li>3.1.7. participate and answers the question set out in Mzansi Rhythm daily
              competitions correctly, thereby earning coins.
            </li>
          </ul>
        </ul>

        <h2>Prizes</h2>
        <p><strong>Airtime Rewards:</strong></p>
        <p>Total annual prize pool: R396 000 (three hundred and ninety-six thousand rand), R33 000 (thirty-three thousand
          rand) monthly as detailed in the table below:</p>

        <table>
          <tr>
            <th>Details of Prizes</th>
            <th>Monthly</th>
          </tr>
          <tr>
            <td>FREE Mode</td>
            <td>R3 000</td>
          </tr>
          <tr>
            <td>VIP Mode</td>
            <td>R30 000</td>
          </tr>
          <tr>
            <td><strong>Total</strong></td>
            <td><strong>R33 000</strong></td>
          </tr>
        </table>

        <h2>Prize Delivery:</h2>
        <p>4.2.1 All MTN airtime and/or data Prizes will be deposited directly into the winner’s
          airtime or data wallet.</p>
        <p>4.2.2 If a winner cannot accept a Prize for any reason whatsoever, the Prize will be
          awarded to the next selected participant.</p>
        <p>A4.2.3 All risks and ownership of the Prizes shall pass to the winners on
          transfer/delivery thereof and hence all of MTN’s obligations regarding the
          promotion as well as in regard to the Prizes shall terminate.</p>

        <h2>4.3 Prize Draws</h2>
        <p>4.3.1 Each coin earned constitutes an entry to the daily draw. If a participant has
          earned 500 (five hundred) coins in the competition, they will have 500 (five
          hundred) entries into the daily draw.</p>
        <p>4.3.2 Winners will be randomly selected daily for the duration of the promotional
          period from all eligible entries who meet all the requirements set out in clause
          3.</p>

        <h2>5 How the Service Works</h2>
        <p>5.1 The participant has to play the Online or USSD game that is available on the
          platform which is part of the Mzansi Rhythm service available on *123#,
          *130*692# and/or <a href="http://mzrhythm.com/">http://mzrhythm.com/</a>.
        </p>
        <p>5.2 To use the Service you must join by:</p>
        <ul>
          <li>5.2.1 Dialling *123#, select option 11 on the menu and follow the prompts or by
            dialling *130*692# and following the prompts.
          </li>
          <li>5.2.2 Mzansi Rhythm is a subscription services with a FREE element to the game.</li>
          <li>You will be eligible to access all the content on the Service free of charge for 1 (one) day (the “Free Trial
            Day”), the Free Trial Day is only applicable if you will be subscribing to the subscription service for R5.00
            (five Rand) per day, R35 (thirty five Rand) per week or R45 (forty five Rand) per month. For the avoidance of
            doubt, you will not be eligible for another Free Trial Day if you cancel your subscription and then re- register
            at a later stage
          </li>
          <li>5.2.2.2 After the Free Trial Day, you will be charged a subscription fee of R5 (five Rand) per day, R35
            (thirty five Rand) per week or R45 (forty five Rand) per Month (incl. VAT) (the “Fee”) for the relevant period
            that you remain subscribed for the service.
          </li>
        </ul>

        <h2>5.3 Unsubscribing from the service.</h2>
        <p>5.3.1 You may unsubscribe from any of the promoted services by dialling *123#,
          selecting option 8 and selecting the service they would like to unsubscribe
          from.</p>

        <h2>6 Mzansi Rhythm Game Structure</h2>
        <p>6.1 Service Tiers: Mzansi Rhythm offers two tiers of service: Free and VIP:</p>
        <ul>
          <li>6.1.1 Free tier allows 7 (seven) text trivia questions per day on both USSD and Web platforms without needing
            to subscribe. Content is detailed in clause 6.2.1 below.
          </li>
          <li>6.1.2 VIP tier, at a cost of R5 (five Rand) per day, R35 (thirty five Rand) per week or R45 (forty five Rand)
            per Month and allows 21 (twenty-one) questions daily and 1 (one) day free trial. Content is detailed in clause
            6.2.1 –6.2.3 below.
          </li>
          <li>6.2 Question Categories: Users answer questions from three categories to earn coins:</li>
          <li>
            6.2.1 Music Trivia Text: These are multiple choice music trivia questions in a text
            format, with 1 (one) correct answer and 2 (two) incorrect options.
          </li>
          <li>
            6.2.2 Guess the Song: User listens to a 20-second music track and guess the song
            with 1 (one) correct and 2 (two) incorrect options.
          </li>
          <li>
            6.2.3 Music Image Trivia: This format presents an image of an artist or image for
            the user to identify, with 1 (one) correct and 2 (two) incorrect options.
          </li>
        </ul>
        <p>
          Note: USSD players, regardless of their package, can only play text trivia questions. To play
          the other categories, users need to log onto the web service on http://mzrhythm.com.
        </p>
        <p>
          6.3 Bonus Round: At the end of a game session, VIP users, have the opportunity to
          participate in a bonus round without incurring any additional cost. This round
          consists of either two &#39;Guess the Song&#39; questions (web) or two &#39;Music Trivia Text&#39;
          questions (USSD). Getting both questions right will double the session&#39;s coin
          earnings, while incorrect answers will halve them.
        </p>
        <p>
          6.4 Access &amp; Platform:
          Available on USSD and Web on *123#, *130*692# and/or http://mzrhythm.com/
        </p>
        <p>
          6.5 Game Mechanics:
        </p>
        <p>
          6.5.1 On first login, a user profile is created in the service Database.
        </p>
        <p>
          6.5.2 This profile tracks the user’s plays and prizes.
        </p>
        <p>
          6.5.3 SMS notifications may occasionally be sent to users. Preferences can be
          managed in the “My Profile” section.
        </p>
        <p>
          6.5.4 Opt-out: Users can opt-out of these notifications by replying with &quot;stop.&quot;
        </p>
        <h2>
          7 Rica
        </h2>
        <p>
          7.1 In terms of the Amended Regulation of Interception of Communications and
          Provision of Communication-related Information Act 70 of 2002 (“RICA”), you are
          obliged to provide proof of your full names, surname, Identity Document number
          and residential address to a RICA officer when purchasing a SIM card. This is
          necessary to activate you as a customer on the MTN network.
        </p>
        <p>
          7.2 MTN is obliged by law not to activate your SIM card on the MTN network if you
          have not complied with the RICA registration requirements.
        </p>
        <p>
          7.3 By law, if a SIM card is lost, stolen or damaged, you are required to immediately
          notify the South African Police Services in writing. You will also have to
          immediately notify MTN and request the SIM card to be suspended.
        </p>
        <p>
          7.4 If you wish to transfer/sell your SIM card to another person (other than a family
          member), you are required to contact your Service Provider to report such a
          transfer to MTN, and MTN is required by law to deactivate the SIM card. Before
          the new holder of the SIM card can use the SIM card, they must provide proof of
          their full names, surname, Identity Document number and residential address to
          an approved MTN RICA officer to register them as a customer on the MTN
          network. Once they have complied with RICA, and the RICA information is
          received by MTN, MTN will reactivate the SIM card.
        </p>
        <p>
          7.5 If you change ownership to a third party, the Promotional Offer is not transferable.
        </p>
        <p>
          Failure by any person holding/using a SIM card to comply with RICA is an offence.
          Contact your service provider or see <a href="www.mtn.co.za">www.mtn.co.za</a> for details.
        </p>
        <h2>8 Modification of Terms and Conditions</h2>
        <p>
          8.1 MTN reserves the right, at any time, to change, vary, amend or replace these
          Terms and Conditions and any rules relating to this Promotional Offer, its
          promotions, its products and services and to modify its promotions, its products
          and services at its discretion, with notice to you.
        </p>
        <p>
          8.2 See <a href="www.mtn.co.za">www.mtn.co.za</a> for product and services rules and updated Terms and
          Conditions from time to time. Any changes to rules and/or Terms and Conditions
          are effective from the date that they are published on the above-mentioned
          website or elsewhere in any media.
        </p>
        <p>
          8.3 MTN reserves the right at any time to modify, suspend or discontinue the services,
          with notice, without liability to you or any third party. MTN will under no
          circumstance be liable to you for any error, delay, failure or non-availability of the
          service, and you indemnify MTN against any damage or loss you may sustain as a
          result of possession and/or use of the SIM card, MTN network services, or any
          error, delay, failure or non-availability of the service. Visit www.mtn.co.za regularly
          for notice, updates and/or changes to services.
        </p>
        <p>
          8.4 MTN reserves the right from time to time to vary the charges of these services as
          may be deemed necessary in its discretion.
        </p>
        <p>
          8.5 As changes will be posted on www.mtn.co.za, your continued use of the products
          and/or services with the amended rules will be deemed to be accepted by you. It
          is the responsibility of you to review these Terms and Conditions regularly.
        </p>
        <h2>9 Limitation of Liability</h2>
        <p>
          9.1 Subject to the provisions of the Consumer Protection Act, to the extent allowed by
          any other applicable law and also subject to clauses 8.2 and 8.3 below, MTN will
          not be liable to you or to any other person for any loss or damage suffered
          (whether it is direct or indirect):
        </p>
        <p>9.2 if MTN does not supply or deliver any device or SIM card/s on the required date or
          time; or</p>
        <p>9.3 if the MTN network services are interrupted, suspended, or cancelled, for
          whatever reason; or</p>
        <p>9.4 if MTN does not suspend the provision of the MTN network services to you after
          you have specifically requested MTN to do so; or</p>
        <p>9.5 if the loss or damage was caused by any negligent act or failure to act by MTN, its
          employees or agents; or</p>
        <p>9.6 as a result of the use of any device supplied to you by MTN relating to this service.</p>
        <p>9.7 Clause 8.1 does not limit or exclude any warranties or obligations which are
          implied into this service by the Consumer Protection Act (to the extent applicable)
          or which MTN gives under the Consumer Protection Act (to the extent applicable),
          to the extent that the law does not allow them to be limited or</p>

        <h2>10 General</h2>
        <p>10.1 Winners will be updated on the leaderboard on https://mzrhythm.com at the end of
          each tournament date.</p>
        <p>10.2 MTN, their respective directors, affiliates, members, partners, employees, agents,
          consultants, suppliers, contractors, subsidiaries and sponsors assume no liability
          whatsoever for any direct or indirect loss or damage, including but not limited to
          physical harm or death, howsoever arising from or as a result of a person
          receiving the Prize and/or the terms and conditions of this Promotion.
          Furthermore, you will be solely responsible for all products used by you.
          Accordingly, the MTN takes no responsibility for any loss or damage, or any MTN
          airtime associated with the SIM card and/or cell phone number. In the event of
          theft or loss of your cell phone, airtime and/or SIM card, such items must be
          replaced at your own cost, and you are obliged to report such loss or theft to the
          South African Police Services immediately. All persons participating in the
          Promotion hereby expressly indemnify the MTN in this regard and shall hold it
          harmless from all and any claims arising from or as a result of the above reasons.</p>
        <p>10.3 See <a href="www.mtn.co.za">www.mtn.co.za</a> for Promotional Offer rules and updated Terms and
          Conditions from time to time. Any changes to rules and/or Terms and Conditions
          are effective from the date that they are published on the website or elsewhere in
          any media.</p>
        <p>10.4 MTN shall be entitled to terminate the Promotional Offer if any customers are
          involved in any fraudulent activity or suspected fraudulent activity.</p>

        <h2>11 Fanclash Privacy Notice</h2>
        <p>This Privacy Notice is for https://mzrhythm.com/ subscribers. Mzansi Rhythm is owned
          by Fanclash South Africa (Pty) Ltd.</p>
        <p>11.1 WHAT WE COLLECT
           We collect your cell phone number. We don’t collect your billing details. MTN
          charges you directly from your available airtime.
           We collect information about your online activity. This includes your login
          information, how many times you log in, how long and how often you play
          games.</p>
        <p>11.2 HOW WE USE IT
           We’ll send you an SMS to confirm that you are subscribed and when you win
          a prize.
           We’ll display your username on our leader board.
           When you unsubscribe from our service, we may send you direct marketing
          about new games and promotions, but you can opt out anytime.</p>
        <p>11.3 WE DON’T SHARE IT UNLESS WE HAVE TO
           We share your information with MTN to allocate your prizes and collect
          subscription fees.
           We may share your information with service providers to help us manage
          operations, e.g., accountants, auditors, and data storage providers. We only
          share the information that the service provider needs – nothing more.
           We only share your personal information if it is necessary to manage our
          relationship with you or MTN.</p>
        <p>11.4 WE ONLY KEEP IT WHILE WE NEED IT
           We keep your information for as long as we really need it. When you
          subscribe, we’ll keep your cell phone number for as long as you have a profile
          and for 6 months after you unsubscribe from our service, to send you
          information about new games and promotions.</p>
        <p>11.5 WE DO OUR BEST TO PROTECT IT
           We have reasonable security measures in place to protect your personal
          information.
           We check our systems regularly for security issues.</p>
        <p>11.6 YOU CAN MANAGE YOUR INFORMATION
          To exercise any of your rights as listed below, simply email us on
          hello@thefanclash.com.with the subject line of what you would like to
          amend/updated or simply tell us what you want to do. Then, we’ll take it from
          there.

           Ask us what we know about you.
           Ask what personal information we share.
           Request access to your record.
           Ask us to update, correct, or delete any personal information we have about
          you.
           Opt out of marketing messages.
           Object to the use of your personal information.
           Complain to the information regulator.

          It may take us up to 21 days to respond because there are procedures we must follow.</p>
        <h2>Fraud Prevention and Platform Security</h2>
        <p>To keep our games fair, we use Cloudflare Turnstile to confirm that you are a real person
          and not an automated program. It runs invisibly in the background, so there is nothing for
          you to do. To carry out this check, Cloudflare may process limited technical information about
          your device and browser on our behalf. Cloudflare does not use this information for advertising
          or to track you across other websites. For more detail, see Cloudflare's Turnstile Privacy
          Addendum: <a href="https://www.cloudflare.com/turnstile-privacy-policy">https://www.cloudflare.com/turnstile-privacy-policy</a>.</p>
        <p>While you play, we also collect technical and interaction signals such as answer timing,
          input patterns, and device and browser characteristics to distinguish genuine human play from
          automated cheating. We use this information only to detect and prevent fraud and abuse, in line
          with the Protection of Personal Information Act (POPIA).</p>
      </div>
      <div class='row justify-content-center'>
      <div class="Backbut mx-auto text-white text-center mt-4 border p-3 col-11" @click = "backProfile">Go Back</div>
      </div>

    </div>

  </div>

</template>

<style scoped>

.Backbut{
  background-color: black;
  border-radius: 30px;
  font-family: "Clash Display", sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 19px;
  color: #FFFFFF;

}

.terms-heading {
  font-family: "Clash Display", sans-serif;
  font-size: 23px;
  font-style: normal;
  font-weight: 600;
}

.terms-body {
  font-family: "Clash Display", sans-serif;
  font-weight: 500;
  font-style: normal;
  font-size: 12px;
  color: #000F56;
}

</style>